import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEventTimeIndicator } from '../../../utils';
import { addLiveBookmarkPopular } from './../../../../../redux/actions/searchActions';

export const useAddBookmark = (beginTime, endTime, id) => {
  const dispatch = useDispatch();
  const popularResult = useSelector(
    state => state.search.searchResults.popular,
  );
  const firstEventLive = popularResult?.find(
    popular => popular?.bookmark !== undefined && popular?.content_type === 'L',
  );
  const hasBookmark = firstEventLive?.bookmark !== undefined;
  const isTimeSet = beginTime === undefined && endTime === undefined;
  useEffect(
    () => {
      const eventTimeIndicator = getEventTimeIndicator(beginTime, endTime);

      if (eventTimeIndicator?.bookmark)
        dispatch(
          addLiveBookmarkPopular({
            id,
            bookmark: eventTimeIndicator?.bookmark,
          }),
        );
    },
    [hasBookmark, isTimeSet],
  );
};
